<template>
    <div class=" section_sectionWrapper">
        <div class="module-news">
            <div class="title"></div>
            <div class="news-cont">

                <div class="news-list-idx">
                    <div class="new-list" v-if="flag">

                        <!-- <img :src="list[0].indexPicUrl == ''  ? require('../../assets/img/news/default-img.png') :  list[0].indexPicUrl" alt=""
                            srcset="" class="defaultImg"> -->
                        <img :src="newsImg" alt="" srcset="" class="defaultImg">
                        <div class="lf-list">
                            <div class="t-tag">
                                <div class="new-tab"></div>
                                <div class="new-more" @click="flag = false"></div>
                            </div>
                            <div class="t-list">
                                <div v-for="(item, index) in list" :key="item.id" class="item" v-if="index < 5">
                                    <div class="item-tag">{{ item.tag }}</div>
                                    <div class="item-title line-clamp-1" @click="showDetail(item)">{{ item.title }}
                                    </div>
                                    <div class="item-time">{{ common.tsformat(item.time) }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="lr-imgurl">

                        </div>
                    </div>
                    <!-- 全部新闻列表 -->
                    <div class="all-list" v-else>
                        <div class="t-tag">
                            <div class="new-tab"></div>
                            <div class="new-back" @click="showNewList()"></div>
                        </div>
                        <div class="t-list">
                            <div v-for="(item, index) in list" :key="item.id" class="item">
                                <div class="item-tag">{{ item.tag }}</div>
                                <div class="item-title line-clamp-1" @click="showDetail(item)">{{ item.title }}</div>
                                <div class="item-time">{{ common.tsformat(item.time) }}</div>
                            </div>
                        </div>
                        <!-- 分页 -->
                        <!-- <div class="new-pagination">
                            <div class="lf-arrow" @click="handlePrev(1)"></div>
                            <div class="buttle">
                                <div class="pag-idx" v-for="idx in totalPage" :key="idx"
                                    :class="idxIndex == idx ? 'active-pag-idx' : ''"></div>
                            </div>
                            <div class="lr-arrow" @click="handleOmega()"></div>
                        </div> -->

                        <div class="new-pagination">
                            <div class="lf-arrow" :class="pageValue == 1 ? 'pointEV' : ''" @click="changePage(pageNumber -= 1)"></div>
                            <div class="buttle">
                                <input name="inputPageNum" v-on:change="changePage($event.target.value)"
                                    v-model="pageValue"
                                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )" min="1" />
                                <span>/</span>    
                               <span> {{ totalPage }}</span>
                            </div>
                            <div class="lr-arrow" :class="pageValue == totalPage ? 'pointEV' : ''" @click="changePage(pageNumber += 1)"></div>
                        </div>


                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            detail: null,
            limit: 10,
            page: 1,
            totalPage: 0,
            idxIndex: 1,
            list: [
                {
                    id: 1,
                    tag: 'お知らせ',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 2,
                    tag: 'イベント',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 3,
                    tag: 'イベント',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 4,
                    tag: 'お知らせ',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 5,
                    tag: 'イベント',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 6,
                    tag: 'お知らせ',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
                {
                    id: 7,
                    tag: 'お知らせ',
                    title: '異なる世界で紡ぐ縁 PV公開記念キャンペーン...',
                    time: '2024-08-14'
                },
            ],
            flag: true,
            newsImg: "",
            pageNumber: 1,       // 页码 
            pageValue: 1,            // input 值
        }
    },
    watch: {

    },
    created() {
        this.newsInitData()
    },
    methods: {
        changePage(e) {
            this.pageNumber = Number(e);
            // 选择、输入 pageNumber 值大于、小于 所需空间 size 将其置为 1
            if (this.pageNumber > this.totalPage || this.pageNumber <= 0) {
                this.pageNumber = 1;
            }
            // 前面页数改变后 input 框页数也要改变
            this.pageValue = this.pageNumber;
            this.newsInitData(this.pageNumber);
        },
        handlePag(val) {
            this.idxIndex = val
        },
        showDetail(item) {
            // this.handleDetail(item.id)
            // this.$router.push({
            //     query: { ...this.$route.query, view: 6, id: item.id }
            // })

            let routeUrl = this.$router.resolve({
                path: "/news/event",
                query: { id: item.id },
            });
            window.open(routeUrl.href, "_blank");

        },
        // handlePrev(item) {
         
        //     this.pageValue = item
        //     this.newsInitData(item);
        // },
        // handleOmega() {
        //     this.newsInitData(this.totalPage);
        //     console.log('item', this.totalPage)
        // },
        showNewList() {
            this.newsInitData(1);
            this.flag = true
        },
        // 获取新闻列表
        newsInitData(take = 1) {
            const reqTime = Math.floor(new Date().getTime() / 1000);
            const gameId = 211;
            const signature = this.common.makeSignature({ gameId }, reqTime);
            const params = { gameId, signature, reqTime };

            this.page = take;
            this.idxIndex = take
            if (this.page > 1) params["page"] = this.page;

            this.$axios({
                method: "post",
                url: "news/query",
                data: params,
                //withCredentials:true, //局部携带cookie
                headers: {}, //如果需要添加请求头可在这写
            })
                .then((res) => {
                    this.list = res.data.data.data;
                    this.totalPage = Math.ceil(res.data.data.total / this.limit);

                    this.newsImg = this.list[0].indexPicUrl == '' ? require('../../assets/img/news/default-img.png') : this.list[0].indexPicUrl
                })
                .catch((err) => {
                    //请求失败就会捕获报错信息
                    //err.response可拿到服务器返回的报错数据
                });
        },


    }
}
</script>
<style lang="scss" scoped>
.module-news {
    position: relative;
    height: 100%;
    width: 100%;


    .title {
        width: 320px;
        height: 105px;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 109px;
        transform: translateX(-50%);
        background-image: url("../../assets/img/news/title.png");
    }

    .news-cont {
        // width: 950px;
        // height: 675px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 55%;
        .pointEV {
            pointer-events: none;
            filter: opacity(.5);
        }

        .t-tag {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 150px 0 80px;
            cursor: pointer;

            .new-tab {
                background: url("../../assets/img/news/new-tab.png") no-repeat;
                background-size: 100% 100%;
                width: 125px;
                height: 49px;
            }

            .new-more {
                background: url("../../assets/img/news/more.png") no-repeat;
                background-size: 100% 100%;
                width: 119px;
                height: 39px;
            }

            .new-back {
                background: url("../../assets/img/news/back.png") no-repeat;
                background-size: 100% 100%;
                width: 119px;
                height: 39px;
            }
        }

        .item {
            display: flex;
            align-items: center;
            gap: 16px;
            height: 62px;
            border-bottom: 1px dashed #bbc8ce;
            width: 570px;
            margin-left: 45px;
            color: #8899a5;

            .item-tag {
                background-color: #9ac9dd;
                padding: 4px 6px;
                color: #fff;
                width: 110px;
                text-align: center;
            }

            .item-title {
                font-size: 16px;
                color: #586776;
                opacity: 0.93;
                padding: 4px 6px;
                font-weight: bold;
                width: 360px;
                cursor: pointer;

            }
        }

        .new-list {

            display: flex;
            align-items: end;
            gap: 99px;
            position: relative;

            .defaultImg {
                display: block;
                width: 644px;
                height: 362px;
                position: absolute;
                top: 0;
                right: 45px;
            }

            .lf-list {

                .t-list {
                    background: url("../../assets/img/news/news-bg.png") no-repeat;
                    background-size: 100% 100%;
                    width: 735px;
                    height: 330px;

                    padding: 32px 0;


                }
            }


            .lr-imgurl {
                background: url("../../assets/img/news/news-img.png") no-repeat;
                background-size: 100% 100%;
                width: 500px;
                height: 354px;

            }
        }

        .all-list {
            .new-pagination {
                width: 350px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 12px auto;
                cursor: pointer;

                .buttle {
                    display: flex;
                    align-items: center;
                    gap: 18px;
                    font-size: 14px;
                    color: #586776;
                    font-weight: bold;
                    
                    input {
                        height: 30px;
                        line-height: 30px;
                        display: inline-block;
                        width: 70px;
                        border: 1px solid #5867769d;
                        border-radius: 4px;
                        text-align: center;
                    }
                }

                .active-pag-idx {
                    background: url("../../assets/img/news/active-pag-idx.png") no-repeat;
                    background-size: 100% 100%;
                    width: 29px;
                    height: 29px;
                }
            }

            .pag-idx {
                width: 10px;
                height: 10px;
                background-color: #92a1aca8;
                border-radius: 50%;

            }

            .t-list {
                background: url("../../assets/img/news/all-newbg.png") no-repeat;
                background-size: 100% 100%;
                display: flex;
                width: 1245px;
                height: 350px;
                flex-wrap: wrap;
                align-content: flex-start;
                padding: 60px;
                justify-content: space-between;

                .item {
                    margin: 0;
                }
            }

            .t-tag {
                margin-right: 28px;
            }

            .lf-arrow {

                background: url("../../assets/img/news/arrow-lf.png") no-repeat;
                background-size: 100% 100%;
                width: 20px;
                height: 23px;
            }

            .lr-arrow {

                background: url("../../assets/img/news/arrow-lr.png") no-repeat;
                background-size: 100% 100%;
                width: 20px;
                height: 23px;
            }
        }

    }


}

@media screen and (max-width: 1200px) {
    .module-news {
        // .title {
        //     width: 288px !important;
        //     height: 94px !important;
        // }

        .news-cont {
            top: 50% !important;
        }
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .module-news {
        .title {
            width: 288px !important;
            height: 94px !important;
        }

        .news-cont {
            top: 57% !important;

            .new-tab {

                width: 112px !important;
                height: 44px !important;
            }

            .new-more,
            .new-back {

                width: 107px !important;
                height: 36px !important;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/news.vue